import JsonScreen from "./JsonScreen";

export default JsonScreen;